import React from 'react';
import { Box, VStack, HStack } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { LuPrinter } from 'react-icons/lu';
import { useTranslation } from '../../hooks/useTranslation';
import { useGetCustomerQuery } from '../../api';
import MailActionCard from '../../components/mail/MailActionCard';
import MailList from '../../components/mail/MailList';
import { TbTruck } from 'react-icons/tb';
import PageTitle from '../../components/base/PageTitle';
import { PaySubscriptionGate } from '../../components/base/PaySubscriptionGate';
import LoadingState from '../../components/base/LoadingState';

const MailPage: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { data: customer, isLoading: isCustomerLoading } = useGetCustomerQuery();

    const handleOpenMailSettings = () => {
        navigate('/mail/settings');
    };

    const handleOpenForwarding = () => {
        navigate('/mail/forwarding');
    };

    if (isCustomerLoading || !customer) {
        return <LoadingState message={t.pages.mail.loading} />;
    }

    if (customer?.status === 'new') {
        return (
            <Box
                flex={1}
                minH={0}
                display="flex"
                flexDirection="column"
                overflow="hidden"
                bg="gray.100"
                maxW="4xl"
            >
                <Box flexShrink={0}>
                    <PageTitle title={t.pages.mail.title} />
                </Box>
                <PaySubscriptionGate />
            </Box>
        );
    }

    return (
        <Box
            flex={1}
            minH={0}
            display="flex"
            flexDirection="column"
            overflow="hidden"
            bg="gray.100"
            maxW="4xl"
            pb={{ base: 20, lg: 0 }}
        >
            <VStack gap={2} align="stretch" flex={1} minH={0} overflow="hidden">
                {/* Заголовок */}
                <Box flexShrink={0}>
                    <PageTitle title={t.pages.mail.title} />
                </Box>

                <HStack
                    flexShrink={0}
                    px={6}
                    gap={4}
                    align="stretch"
                    w={{ base: 'full', md: '600px' }}
                    mx="auto"
                >
                    {/* Блок настройки входящей почты */}
                    <MailActionCard
                        icon={LuPrinter}
                        label={t.pages.mail.incomingMailSettings}
                        onClick={handleOpenMailSettings}
                    />

                    {/* Блок пересылки писем */}
                    <MailActionCard
                        icon={TbTruck}
                        label={t.pages.mail.forwarding}
                        onClick={handleOpenForwarding}
                    />
                </HStack>

                {/* Список писем */}
                <Box
                    flex={1}
                    minH={0}
                    pt={6}
                    px={6}
                    bg="white"
                    mt={2}
                    w={{ base: 'full', md: '600px' }}
                    maxW="600px"
                    mx="auto"
                    overflow="hidden"
                    display="flex"
                    flexDirection="column"
                >
                    <MailList />
                </Box>
            </VStack>
        </Box>
    );
};

export default MailPage;
